import { Component } from '@angular/core';

import { EventCentreDialogService } from '../dialog';

@Component({
    selector: 'cmps-event-centre-nav-button]',
    templateUrl: './event-centre-nav-button.component.html',
    host: {
        class: 'cmps-event-centre-nav-button',
    },
})
export class EventCentreNavButtonComponent {
    constructor(
        /** @private */ readonly _dialogService: EventCentreDialogService,
    ) {}
}
